import React, { ReactElement, useMemo } from 'react';
import DOMPurify from 'dompurify';
import { useTranslation } from 'react-i18next';

import { SectionContainer } from 'pages/RecommendationV2/V2Common.styles';
import { useAppState } from 'context/AppState';

import {
  SectionWrapper,
  SectionTitle,
  DisclaimerText,
  NotesContent,
  ContentColumn,
} from './FranchiseeNotes.styles';

import franchiseeIcon from '../../../../assets/icons/Franchisee_icon.svg';

interface FranchiseeNotesProps {
  readonly sectionRef?: React.Ref<HTMLDivElement>;
}

export function FranchiseeNotes({ sectionRef }: FranchiseeNotesProps): ReactElement | null {
  const { t } = useTranslation();

  const {
    apiData: { recommendationCropwise },
  } = useAppState();

  const franchiseeNotes: string | undefined =
    recommendationCropwise?.recommendations?.[0]?.multi_field?.config?.agronomicInputs
      ?.extended_attributes?.franchisee_notes;

  const sanitizedHtml = useMemo(() => {
    if (!franchiseeNotes) {
      return '';
    }
    return DOMPurify.sanitize(franchiseeNotes);
  }, [franchiseeNotes]);

  if (!franchiseeNotes) {
    return null;
  }

  return (
    <div ref={sectionRef}>
      <SectionContainer>
        <SectionWrapper>
          <img src={franchiseeIcon} alt="" />
          <ContentColumn>
            <SectionTitle level={3}>{t('Additional Information by Franchisee')}</SectionTitle>

            <DisclaimerText>
              {t(
                'This note is submitted by the franchisee and reflects their thoughts and opinions Syngenta shall not be liable for any losses arising out of reliance on this recommendation'
              )}
            </DisclaimerText>

            <NotesContent dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
          </ContentColumn>
        </SectionWrapper>
      </SectionContainer>
    </div>
  );
}

export default FranchiseeNotes;
